import React, { useEffect, useState } from "react";
import Header from "../../componets/Header";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { Button, Col, Container, Row } from "react-bootstrap";
import AlertService from "../../helper/alertService";
import ApiService from "../../helper/api";

function Component(props) {
	const { walletInfo } = useLoaderData();
	const navaigate = useNavigate();
	const [data, setData] = useState(null);

	useEffect(() => {
		if (!walletInfo) {
			AlertService.alert("error", "No Information");
			navaigate(-1);
		}
	}, [walletInfo]);

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/merchant-wallets">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Wallet info</h4>
					</div>
				</div>
			</Header>
			<Row>
				<Col sm={12}>
					<hr />
				</Col>
			</Row>
			<Container style={{ paddingBlockEnd: "40px" }}>
				<Row className="pb-4">
					<Col>
						<h5>
							<b>Wallet address {walletInfo?.address}</b>
						</h5>
					</Col>
					<Col sm={12} className="mt-3 d-flex flex-column gap-3">
						{walletInfo &&
							walletInfo?.chains.map((coinData, index) => {
								return (
									<div key={index}>
										<div className="d-flex align-items-center mb-2">
											<img
												className="me-2"
												src={coinData.chainLogo}
												width={40}
												alt="logo"
											/>
											<h2 className="text-left">
												<b>{coinData.chainSlug}</b> ({coinData.chainName})
											</h2>
											Balance {coinData.chainBalance}
											(
											<img
												className="me-2"
												src={coinData.chainLogo}
												width={20}
												alt="logo"
											/>{" "}
											<b>{coinData.currencySlug}</b>)
										</div>
										<div className="ps-5 d-flex flex-column gap-2">
											{coinData.contracts &&
												coinData.contracts?.map((contract, i) => {
													return (
														<div key={i}>
															<div className="d-flex align-items-center gap-1">
																<b>{contract.contractBalance}</b>
																<img
																	className="me-2"
																	src={contract.logo}
																	width={20}
																	alt="logo"
																/>
																<p className="p-0 m-0">
																	<b>{contract.slug}</b>({contract.name}
																	)&#x2192;{contract.contractAddress}
																</p>
															</div>
														</div>
													);
												})}
										</div>
										<hr />
									</div>
								);
							})}
					</Col>
					<Col></Col>
				</Row>
			</Container>
		</div>
	);
}

const loader = async ({ _, params: { walletId } }) => {
	try {
		const walletInfo = await ApiService.walletGetWalletBalance(walletId)
			.then(response => {
				if (response.data) {
					return response.data;
				} else {
					return null;
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});

		return { walletInfo: walletInfo || null };
	} catch (error) {
		AlertService.alert("error", error);
		return error;
	}
};

const WalletInfo = Object.assign(Component, { loader });

export default WalletInfo;
